<template>
    <div>
        <label class="block text-sm font-medium leading-5 text-gray-800 relative"
            :class="{'required': required}"
            :for="name">
            {{ label }}
            <font-awesome-icon class="text-xs text-black ml-1 cursor-pointer"
                :icon="['fas', 'question-circle']"
                style="margin-top: 2px;"
                v-if="tooltip" v-tooltip="tooltip" />
        </label>
        <div class="mt-1">
            <ValidationProvider :name="label" mode="lazy" :rules="rules" v-slot="{ errors }" tag="div">
                <div class="mt-1">
                    <input :type="type ? type : 'text'"
                        v-model="model"
                        :value="value"
                        :id="name"
                        @input="onInput"
                        :name="name"
                        ref="autocomplete"
                        :placeholder="placeholder ? placeholder : ''"
                        :readonly="readonly"
                        :disabled="disabled"
                        autocomplete="Off"
                        data-lpignore="true"
                        class="form-input block w-full transition duration-150 ease-in-out sm:text-sm leading-none text-gray-700"
                        :class="{ 'border-red-700' : errors[0], 'opacity-50 cursor-not-allowed' : disabled, 'readonly bg-gray-200 cursor-default border-gray-400' : readonly }"
                    />
                </div>
                <span class="text-xs text-red-700 absolute">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InputAddressAutocomplete",
        props: ['label', 'value', 'name', 'placeholder', 'readonly', 'validation', 'delay', 'dictionary', 'mask', 'required', 'disabled', 'type', 'separate', 'tooltip', 'rules'],
        data: function(){
            return {
                model: null,
                address: {
                    address_1: '',
                    address_2: '',
                    suburb: '',
                    postcode: '',
                    state: '',
                    country: ''
                }
            }
        },
        mounted() {
            if (this.value && !this.model){
                this.model = this.value;
            }

            if (!this.disabled && !this.readonly) {
                window.loader
                    .load()
                    .then(() => {
                        this.autocomplete = new google.maps.places.Autocomplete(this.$refs.autocomplete);

                        this.autocomplete.addListener('place_changed', () => {
                            this.address = {
                                address_1: '',
                                address_2: '',
                                suburb: '',
                                postcode: '',
                                state: '',
                                country: '',
                                latitude: null,
                                longitude: null
                            };

                            let place = this.autocomplete.getPlace();

                            place.address_components.forEach((component) => {
                                if (component.types.indexOf('street_number') !== -1) {
                                    this.address.address_1 += component.short_name;
                                } else if (component.types.indexOf('route') !== -1) {
                                    this.address.address_1 += ' ' + component.short_name;
                                } else if (component.types.indexOf('locality') !== -1) {
                                    this.address.suburb = ' ' + component.short_name;
                                } else if (component.types.indexOf('administrative_area_level_1') !== -1) {
                                    this.address.state = ' ' + component.short_name;
                                } else if (component.types.indexOf('country') !== -1) {
                                    this.address.country = ' ' + component.long_name;
                                } else if (component.types.indexOf('postal_code') !== -1) {
                                    this.address.postcode = ' ' + component.short_name;
                                }
                            });

                            this.address.latitude = place.geometry.location.lat();
                            this.address.longitude = place.geometry.location.lng();

                            this.model = this.address.address_1;

                            if (this.separate) {
                                this.$emit('selected', this.address);
                            }

                        });
                    })
                    .catch(e => {
                        // do something
                    });
            }

            const options = {
                version: "weekly",
                libraries: ['geometry', 'places'],
                region: 'AU'
            };
        },
        methods: {
            onInput (event) {
                if (event.target){
                    this.$emit('input', event.target.value);
                } else {
                    // Used for Masked Input
                    this.$emit('input', event);
                }
            }
        }
    }
</script>

<style scoped>

</style>
